import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

const getActionTemplate = ({ actor, action }) => {
    const { target, type } = action
    if (!target) {
        return 'No available targets.'
    }
    const { faction: targetFaction, name: targetName } = target
    if (type === 'death') {
        return (
            <React.Fragment>
                <span role="img" aria-label="status">
                    {'☠️ '}
                </span>
                <b className={targetFaction}>
                    {targetName}
                </b>
                {' died.'}
            </React.Fragment>
        )
    }
    const actorName = actor.name
    const actorFaction = actor.faction
    const { damage } = action.changedStatus
    switch (action.type) {
        case 'attack': {
            return (
                <React.Fragment>
                    <b className={actorFaction}>
                        {actorName}
                    </b>
                    {' attacks '}
                    <b className={targetFaction}>
                        {targetName}
                    </b>
                    {` for ${damage} damage.`}
                </React.Fragment>
            )
        }
        default: {
            return 'Something strange happened and we weren\'t able to log it. Sorry!'
        }
    }
}

const BattleLogEntry = ({ entry }) => {
    const { timestamp } = entry
    const formatedTimestamp = dayjs(timestamp).format('H:mm:ss')

    return (
        <p>
            {`[${formatedTimestamp}] `}
            {getActionTemplate(entry)}
        </p>
    )
}

BattleLogEntry.propTypes = {
    entry: PropTypes.object.isRequired,
}

export default BattleLogEntry
